import React from 'react';

import { Paper } from '@material-ui/core';

import { useTicketsMode } from '../../state/index.hooks';
import TicketPreviewPane from './TicketPreviewPane';
import TicketEditForm from './TicketEditForm';
import { useToolkitDispatch } from './../../../../hooks';
import { changeTicketPaneMode } from '../../state';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    refreshGrid: () => void;
}
const TicketsPane = ({ refreshGrid }: IOwnProps) => {
    const classes = useStyles();
    const toolkitDispatch = useToolkitDispatch();

    const mode = useTicketsMode();

    const handleChangeMode = (mode: 'edit' | 'preview') => {
        toolkitDispatch(changeTicketPaneMode(mode));
    };
    const renderPane = () => {
        switch (mode) {
            case 'preview':
                return (
                    <TicketPreviewPane handleChangeMode={handleChangeMode} />
                );
            case 'edit':
                return <TicketEditForm refreshGrid={refreshGrid} />;

            default:
                return <></>;
        }
    };
    return (
        <Paper className={classes.formPane}>
            <div className={classes.wrapper}>{renderPane()}</div>
        </Paper>
    );
};

export default TicketsPane;
